import { IconButton, Tag, Typography } from "@suraasa/placebo-ui"
import {
  LeadQualification,
  qualificationLevelChoices,
} from "api/resources/lead/types"
import { format } from "date-fns"
import { EditPencil, Trash } from "iconoir-react"
import { useState } from "react"
import { useResource } from "utils/hooks/useResource"

import QualificationDeleteDialog from "../QualificationDeleteDialog"
import QualificationFormDialog from "../QualificationDialog"

type Props = {
  data: LeadQualification
  onUpdate?: () => void
  onDelete?: () => void
}

enum DialogAction {
  UPDATE = "update",
  DELETE = "delete",
}

const QualificationRow = ({ data: qualification, ...props }: Props) => {
  const { subjects } = useResource(["subjects"])

  const getSubject = (id: string | null) =>
    subjects.find(x => x.uuid === id)?.name

  const [dialogType, setDialogType] = useState<DialogAction | null>(null)

  return (
    <div className="flex items-start justify-between py-1">
      <QualificationDeleteDialog
        open={dialogType === DialogAction.DELETE}
        qualification={qualification}
        onDelete={props.onDelete}
        handleClose={() => setDialogType(null)}
      />

      <QualificationFormDialog
        onUpdate={props.onUpdate}
        open={dialogType === DialogAction.UPDATE}
        handleClose={() => setDialogType(null)}
        data={qualification}
      />

      <div>
        <div className="mb-0.5 flex items-center gap-0.5">
          <Typography variant="strong">{qualification.name}</Typography>
        </div>

        <Typography className="mb-0.25 text-onSurface-800" variant="body">
          {[
            qualificationLevelChoices.find(q => q.value === qualification.level)
              ?.label,
            getSubject(qualification.subjectId),
          ]
            .filter(Boolean)
            .join(" • ")}
        </Typography>

        <Typography className="mb-0.25 text-onSurface-500" variant="body">
          {qualification.institutionName}
        </Typography>

        {(qualification.startDate || qualification.endDate) && (
          <Typography variant="body" className="text-onSurface-500">
            {[
              qualification.startDate
                ? format(new Date(qualification.startDate), "MMMM yyyy")
                : "",
              qualification.endDate
                ? format(new Date(qualification.endDate), "MMMM yyyy")
                : "",
            ]
              .filter(Boolean)
              .join(" - ")}
          </Typography>
        )}
      </div>
      <div className="flex items-center gap-2">
        {!qualification.qualificationType && (
          <button
            onClick={() => {
              setDialogType(DialogAction.UPDATE)
            }}
          >
            <Tag color="onSurface">Select Qualification Type</Tag>
          </button>
        )}

        <IconButton
          onClick={() => {
            setDialogType(DialogAction.UPDATE)
          }}
        >
          <EditPencil />
        </IconButton>
        <IconButton
          color="critical"
          onClick={() => {
            setDialogType(DialogAction.DELETE)
          }}
        >
          <Trash />
        </IconButton>
      </div>
    </div>
  )
}

export default QualificationRow
